import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { SnackerService } from 'src/app/shared/snacker.service';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { FunctionEnum } from 'src/models/others/FunctionEnum';
import { StorageEnum } from 'src/models/others/StorageEnum';
import { RequestBody } from 'src/models/request/RequestBody';
import { UpdatePassword } from 'src/models/request/UpdatePassword';
import { ResponseBody } from 'src/models/response/ResponseBody';
import { UpdateResponse } from 'src/models/response/UpdateResponse';
import { WebserviceService } from 'src/services/webservice';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, NgxSpinnerModule, MatSnackBarModule],
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {
  resetPassForm: FormGroup;
  confirmed = false;
  userName;
  updatePassword: UpdatePassword = new UpdatePassword;
  updateRequestBase: RequestBody = new RequestBody;
  updateResponse: UpdateResponse = new UpdateResponse;
  responseUpdateBase: ResponseBody = new ResponseBody;
  oldPassword:string;
  show: boolean = false;
  passwordState: string = "fa-solid fa-eye";

  constructor(private formBuilder: FormBuilder, private router: Router, private webservice: WebserviceService,
    private snacker: SnackerService,private spinner:NgxSpinnerService) {
    try {
      this.oldPassword = this.router.getCurrentNavigation().extras.queryParams['key'];
    } catch (error) {

    }
  }
  ngOnInit(): void {
    
    this.resetPassForm = this.formBuilder.group({
      newPassword: [null, Validators.required],
      confirmPassword: [null, Validators.required],
      oldPassword: [this.oldPassword, Validators.required]
    });
    if(this.f.oldPassword.value == null){
      this.snacker.error(" please try again");
      this.webservice.navigateToLogin();
    }
    this.userName = sessionStorage.getItem(StorageEnum.getPersonName);
  }
  get f() {
    return this.resetPassForm.controls;
  }
  showPassword() {
    if (this.resetPassForm.controls.newPassword.value != "") {
      this.show = !this.show;
      if (this.show) {
        this.passwordState = "fa-solid fa-eye-slash";
      }
      else {
        this.passwordState = "fa-solid fa-eye";
      }
    }
  }
  onConfirm() {
    this.confirmed = true;
    if (this.f.newPassword.value == null || this.f.confirmPassword.value == null) {
      this.snacker.error("enter Password details")
      return null;
    }
   else if(this.f.confirmPassword.value != this.f.newPassword.value){
      this.snacker.error("Password Not Matching")
      return null;
    }
    this.spinner.show();
    this.updatePassword.newPassword = this.f.newPassword.value;
    this.updatePassword.oldPassword = this.f.oldPassword.value;
    this.updateRequestBase.function = FunctionEnum.UpdatePass;
    this.updateRequestBase.userName = sessionStorage.getItem(StorageEnum.getUserName);
    this.updateRequestBase.payload = this.updatePassword;
    this.webservice.updatePasswordRequest(this.updateRequestBase).subscribe((response: any) => {
      this.spinner.hide();
      if (response != null) {
        this.responseUpdateBase = response;
        if (this.responseUpdateBase.result == 'fail') {
          this.snacker.error(this.responseUpdateBase.resultmessage);
        }
        else {
          this.router.navigate(['login']);
        }
      }
    }, () => {
      this.spinner.hide();
      this.snacker.error("Server error");
      this.webservice.navigateToLogin()

    }
    );
  }

}